module.exports = __webpack_public_path__ + "static/img/蒙版组 12.49a0239.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/images/蒙版组 12.png
// module id = 12+S
// module chunks = 0